"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultInfoTextConfig = exports.defaultCopyrightTextConfig = exports.defaultImageConfig = void 0;
var defaultImageConfig = {
    center: true,
    margin: {
        desktop: '0 0 10px',
        tablet: '0 0 10px',
        mobile: '0 0 10px'
    },
    imageConfig: {
        width: '200px',
        shadow: 'none',
        border: 'none'
    }
};
exports.defaultImageConfig = defaultImageConfig;
var defaultCopyrightTextConfig = {
    fontSize: '14px',
    defaultCss: {
        textAlign: 'center'
    }
};
exports.defaultCopyrightTextConfig = defaultCopyrightTextConfig;
var defaultInfoTextConfig = {
    fontSize: '12px',
    defaultCss: {
        textAlign: 'center'
    }
};
exports.defaultInfoTextConfig = defaultInfoTextConfig;
//# sourceMappingURL=Footer.js.map